<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
		</div>
		<div class="orderListBox">
			<div class="orderMenu">
				<div class="menuItem">序号</div>
				<div class="menuItem">订单信息</div>
				<div class="menuItem">兑换积分</div>
				<div class="menuItem">订单操作</div>
			</div>
			<div class="orderList" v-if="integralData.length">
				<div class="orderItem" v-for="(item,index) in integralData" :key="index">
					<div class="indexNum">{{index + 1}}</div>
					<div class="checkImgGoodsInfoBox">
						<div class="goodsInfoBox">
							<img class="goodsImg" :src="item.goods_img" />
							<div class="goodsInfo">
								<div class="goodsTitle ellipsis-1">{{item.goods_name}}</div>
								<div class="goodsDesc">
									<div class="goodsDescItem" style="margin-right: .16rem;">
										资源类型：{{item.top_title}}
									</div>
									<div class="goodsDescItem">
										{{item.top_title}}类别：{{item.cid}}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="goodsPrice">
						{{item.pay_price}}
					</div>
					<div class="operation">
						<div class="downloadSbsar" v-if="item.top_title == '材质'" @click="downloadImages(item.obj_file)">
							下载SBSAR文件</div>
						<div class="download3d" v-if="item.top_title == '模型'" @click="downloadImages(item.obj_file)">
							下载3D文件</div>
						<div class="look" v-if="item.top_title == '材质'"
							@click="curGoods = item;dialogReportVisible = true">
							查看高清大图</div>
						<div class="look" v-if="item.top_title == '模型'" @click="curGoods = item;dialog3DVisible = true">
							查看3D效果</div>
					</div>
				</div>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
		</div>
		<PagePagination style="padding: .08rem 0 0;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
		<WorkDetailsDialog :show="workDetailsShow" :isBuy="1" :goodsId="curGoods.goods_id"
			@close="workDetailsShow = false" />
		<LookDetailsDialog :show="dialogReportVisible" :data="{img: curGoods.gq_img}"
			@close="dialogReportVisible = false" />
		<ThreeDimensionalDialog :show="dialog3DVisible" @close="dialog3DVisible = false;curGoods = {}"
			:objFileUrl="curGoods.obj_file" />
	</div>
</template>

<script>
	import WorkDetailsDialog from '../components/WorkDetailsDialog.vue'
	import LookDetailsDialog from '../components/LookDetailsDialog.vue'
	import ThreeDimensionalDialog from '../components/ThreeDimensionalDialog.vue'
	export default {
		name: 'ExchangeWorks',
		components: {
			WorkDetailsDialog,
			LookDetailsDialog,
			ThreeDimensionalDialog
		},
		data() {
			return {
				// 分类导航
				categories: [{
						key: '1',
						name: '材质作品'
					},
					{
						key: '2',
						name: '模型作品'
					}
				],
				total: 0,
				curGoods: {},
				curOrder: {},
				currentPage: 1,
				integralData: [],
				activeCategory: '1',
				dialog3DVisible: false,
				workDetailsShow: false,
				dialogReportVisible: false,
				deadline4: Date.now() + (new Date().setHours(23, 59, 59) - Date.now()),
			}
		},
		mounted() {
			if (this.$route.query.activeCategory) {
				this.activeCategory = this.$route.query.activeCategory
			}
			this.integralOrderList()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.integralOrderList()
			},
			// 切换分类
			switchCategory(category) {
				this.currentPage = 1
				this.activeCategory = category;
				this.integralOrderList()
			},
			naviToDetails(item) {
				this.$router.push({
					path: '/order-details',
					query: {
						type: 4,
						orderId: item.id
					}
				})
			},
			async downloadImages(url) {
				if (window.innerWidth <= 480) return this.$message.warning('请到电脑端登录操作')
				try {
					// 使用 fetch 获取原图 Blob
					const response = await fetch(url, {
						mode: 'cors'
					});
					const blob = await response.blob();

					// 创建临时 a 标签下载
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = this.getFileNameFromUrl(url); // 使用原始文件名
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					// 释放对象 URL
					URL.revokeObjectURL(link.href);
				} catch (err) {
					console.error('下载失败', url, err);
				}
			},
			getFileNameFromUrl(url) {
				return url.substring(url.lastIndexOf('/') + 1);
			},
			confirmOrder(item) {
				this.$confirm('当前订单确认收货吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/OrderIntegral/integral_order_sh', {
						order_id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.integralOrderList()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			delOrder(item) {
				this.$confirm('确认删除当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/OrderIntegral/order_integral_del', {
						order_id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.integralOrderList()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			integralOrderList() {
				this.$api.post('/Order/order_list', {
					p: this.currentPage,
					type: this.activeCategory
				}).then(res => {
					if (res.code == 1) {
						this.total = res.data.count
						this.integralData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: 0 .4rem .24rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .32);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: rgba(255, 255, 255, .6);
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: rgba(255, 255, 255, 1);
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: rgba(255, 255, 255, 1);
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: rgba(22, 115, 230, 1);
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	@media (max-width: 480px) {
		.orderMenu {
			display: flex;
			align-items: center;

			.menuItem {
				height: .5rem;
				font-weight: 400;
				font-size: .14rem;
				color: rgba(255, 255, 255, .4);
				text-align: center;
				line-height: .5rem;
			}

			.menuItem:nth-child(1) {
				width: .6rem;
			}

			.menuItem:nth-child(2) {
				width: 5rem;
			}

			.menuItem:nth-child(3) {
				width: 1.4rem;
			}

			.menuItem:nth-child(4) {
				width: 4.2rem;
			}
		}

		.orderItem {
			display: flex;
			align-items: center;
			margin-bottom: .16rem;

			.indexNum {
				display: flex;
				align-items: center;
				justify-content: center;
				width: .6rem;
				font-weight: 700;
				font-size: .16rem;
				color: #FFFFFF;
			}

			.checkImgGoodsInfoBox {
				width: 5rem;
				display: flex;
				align-items: center;

				.goodsInfoBox {
					display: flex;
					align-items: center;

					.goodsImg {
						margin-left: .44rem;
						width: 1rem;
						height: 1rem;
						border-radius: .08rem;
						overflow: hidden;
						object-fit: cover;
					}

					.goodsInfo {
						width: 5rem;
						transform: scale(.8);
						margin-left: .16rem;
						display: flex;
						flex-direction: column;

						.goodsTitle {
							font-weight: 700;
							font-size: .24rem;
							color: #FFFFFF;
							line-height: .22rem;
						}

						.goodsDesc {
							margin-top: .16rem;
							font-weight: 400;
							font-size: .12rem;
							color: rgba(153, 153, 153, 1);
							line-height: .16rem;
							display: flex;
							align-items: center;
						}

						.tips {
							margin-top: .12rem;
							display: flex;
							align-items: center;

							.tip {
								height: .26rem;
								padding: 0 .08rem;
								border-radius: .13rem;
								border: .01rem solid #A88653;
								line-height: .24rem;
								font-weight: 400;
								font-size: .12rem;
								color: #7C3E0B;
							}
						}
					}
				}
			}

			.goodsPrice {
				width: 1.4rem;
				font-weight: 700;
				font-size: .14rem;
				color: #FFFFFF;
				text-align: center;
			}

			.operation {
				width: 4.2rem;
				display: flex;
				align-items: center;
				justify-content: center;

				.downloadSbsar {
					margin-right: .08rem;
					display: flex;
					align-items: center;
					justify-content: center;
					width: 2rem;
					height: .6rem;
					background: #1673E6;
					border-radius: .3rem;
					font-weight: 400;
					font-size: .2rem;
					color: #FFFFFF;
					line-height: .4rem;
					cursor: pointer;
				}

				.download3d {
					margin-right: .08rem;
					display: flex;
					align-items: center;
					justify-content: center;
					width: 1.8rem;
					height: .6rem;
					background: #1673E6;
					border-radius: .3rem;
					font-weight: 400;
					font-size: .2rem;
					color: #FFFFFF;
					line-height: .4rem;
					cursor: pointer;
				}

				.look {
					margin-left: .08rem;
					display: flex;
					align-items: center;
					justify-content: center;
					height: .6rem;
					padding: 0 .16rem;
					border-radius: .3rem;
					border: .01rem solid #FFFFFF;
					font-weight: 400;
					font-size: .2rem;
					color: #FFFFFF;
					line-height: .4rem;
					cursor: pointer;
				}
			}
		}
	}

	@media (min-width: 481px) {
		.orderMenu {
			display: flex;
			align-items: center;

			.menuItem {
				height: .5rem;
				font-weight: 400;
				font-size: .14rem;
				color: rgba(255, 255, 255, .4);
				text-align: center;
				line-height: .5rem;
			}

			.menuItem:nth-child(1) {
				width: .6rem;
			}

			.menuItem:nth-child(2) {
				width: 4rem;
			}

			.menuItem:nth-child(3) {
				width: 1.4rem;
			}

			.menuItem:nth-child(4) {
				width: 2.75rem;
			}
		}

		.orderItem {
			display: flex;
			align-items: center;
			margin-bottom: .16rem;

			.indexNum {
				display: flex;
				align-items: center;
				justify-content: center;
				width: .6rem;
				font-weight: 700;
				font-size: .16rem;
				color: #FFFFFF;
			}

			.checkImgGoodsInfoBox {
				width: 4rem;
				display: flex;
				align-items: center;

				.goodsInfoBox {
					display: flex;
					align-items: center;

					.goodsImg {
						margin-left: .44rem;
						width: 1rem;
						height: 1rem;
						border-radius: .08rem;
						overflow: hidden;
						object-fit: cover;
					}

					.goodsInfo {
						width: 2.1rem;
						margin-left: .16rem;
						display: flex;
						flex-direction: column;

						.goodsTitle {
							font-weight: 700;
							font-size: .16rem;
							color: #FFFFFF;
							line-height: .22rem;
						}

						.goodsDesc {
							margin-top: .16rem;
							font-weight: 400;
							font-size: .12rem;
							color: rgba(153, 153, 153, 1);
							line-height: .16rem;
							display: flex;
							align-items: center;
						}

						.tips {
							margin-top: .12rem;
							display: flex;
							align-items: center;

							.tip {
								height: .26rem;
								padding: 0 .08rem;
								border-radius: .13rem;
								border: .01rem solid #A88653;
								line-height: .24rem;
								font-weight: 400;
								font-size: .12rem;
								color: #7C3E0B;
							}
						}
					}
				}
			}

			.goodsPrice {
				width: 1.4rem;
				font-weight: 700;
				font-size: .14rem;
				color: #FFFFFF;
				text-align: center;
			}

			.operation {
				width: 2.75rem;
				display: flex;
				align-items: center;
				justify-content: center;

				.downloadSbsar {
					margin-right: .08rem;
					display: flex;
					align-items: center;
					justify-content: center;
					width: 1.38rem;
					height: .36rem;
					background: #1673E6;
					border-radius: .18rem;
					font-weight: 400;
					font-size: .14rem;
					color: #FFFFFF;
					line-height: .2rem;
					cursor: pointer;
				}

				.download3d {
					margin-right: .08rem;
					display: flex;
					align-items: center;
					justify-content: center;
					width: 1.06rem;
					height: .36rem;
					background: #1673E6;
					border-radius: .18rem;
					font-weight: 400;
					font-size: .14rem;
					color: #FFFFFF;
					line-height: .2rem;
					cursor: pointer;
				}

				.look {
					margin-left: .08rem;
					display: flex;
					align-items: center;
					justify-content: center;
					height: .36rem;
					padding: 0 .08rem;
					border-radius: .18rem;
					border: .01rem solid #FFFFFF;
					font-weight: 400;
					font-size: .14rem;
					color: #FFFFFF;
					line-height: .2rem;
					cursor: pointer;
				}
			}
		}
	}

	.orderListBox {
		display: flex;
		flex-direction: column;

		.orderList {
			margin-top: .1rem;
			display: flex;
			flex-direction: column;

			// .orderItem {
			// 	display: flex;
			// 	align-items: center;
			// 	margin-bottom: .16rem;

			// 	.indexNum {
			// 		display: flex;
			// 		align-items: center;
			// 		justify-content: center;
			// 		width: .6rem;
			// 		font-weight: 700;
			// 		font-size: .16rem;
			// 		color: #FFFFFF;
			// 	}

			// 	.checkImgGoodsInfoBox {
			// 		width: 4rem;
			// 		display: flex;
			// 		align-items: center;

			// 		.goodsInfoBox {
			// 			display: flex;
			// 			align-items: center;

			// 			.goodsImg {
			// 				margin-left: .44rem;
			// 				width: 1rem;
			// 				height: 1rem;
			// 				border-radius: .08rem;
			// 				overflow: hidden;
			// 				object-fit: cover;
			// 			}

			// 			.goodsInfo {
			// 				width: 2.1rem;
			// 				margin-left: .16rem;
			// 				display: flex;
			// 				flex-direction: column;

			// 				.goodsTitle {
			// 					font-weight: 700;
			// 					font-size: .16rem;
			// 					color: #FFFFFF;
			// 					line-height: .22rem;
			// 				}

			// 				.goodsDesc {
			// 					margin-top: .16rem;
			// 					font-weight: 400;
			// 					font-size: .12rem;
			// 					color: rgba(153, 153, 153, 1);
			// 					line-height: .16rem;
			// 					display: flex;
			// 					align-items: center;
			// 				}

			// 				.tips {
			// 					margin-top: .12rem;
			// 					display: flex;
			// 					align-items: center;

			// 					.tip {
			// 						height: .26rem;
			// 						padding: 0 .08rem;
			// 						border-radius: .13rem;
			// 						border: .01rem solid #A88653;
			// 						line-height: .24rem;
			// 						font-weight: 400;
			// 						font-size: .12rem;
			// 						color: #7C3E0B;
			// 					}
			// 				}
			// 			}
			// 		}
			// 	}

			// 	.goodsPrice {
			// 		width: 1.4rem;
			// 		font-weight: 700;
			// 		font-size: .14rem;
			// 		color: #FFFFFF;
			// 		text-align: center;
			// 	}

			// 	.operation {
			// 		width: 2.75rem;
			// 		display: flex;
			// 		align-items: center;
			// 		justify-content: center;

			// 		.downloadSbsar {
			// 			margin-right: .08rem;
			// 			display: flex;
			// 			align-items: center;
			// 			justify-content: center;
			// 			width: 1.38rem;
			// 			height: .36rem;
			// 			background: #1673E6;
			// 			border-radius: .18rem;
			// 			font-weight: 400;
			// 			font-size: .14rem;
			// 			color: #FFFFFF;
			// 			line-height: .2rem;
			// 			cursor: pointer;
			// 		}

			// 		.download3d {
			// 			margin-right: .08rem;
			// 			display: flex;
			// 			align-items: center;
			// 			justify-content: center;
			// 			width: 1.06rem;
			// 			height: .36rem;
			// 			background: #1673E6;
			// 			border-radius: .18rem;
			// 			font-weight: 400;
			// 			font-size: .14rem;
			// 			color: #FFFFFF;
			// 			line-height: .2rem;
			// 			cursor: pointer;
			// 		}

			// 		.look {
			// 			margin-left: .08rem;
			// 			display: flex;
			// 			align-items: center;
			// 			justify-content: center;
			// 			height: .36rem;
			// 			padding: 0 .08rem;
			// 			border-radius: .18rem;
			// 			border: .01rem solid #FFFFFF;
			// 			font-weight: 400;
			// 			font-size: .14rem;
			// 			color: #FFFFFF;
			// 			line-height: .2rem;
			// 			cursor: pointer;
			// 		}
			// 	}
			// }
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;


				.wuLiuContent {
					margin-bottom: .16rem;
					font-weight: 400;
					font-size: .14rem;
					line-height: .2rem;
					color: #252525;
				}

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .16rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>